import React, { Fragment, useEffect, useRef, useState } from 'react';
import SubscriptionDetails from './details/SubscriptionDetails';
import { stateRender } from '../../../../helpers/react';
import {
	ERROR_GENERIC,
	SUBSCRIPTION_ERROR_NOCANCEL,
	SUBSCRIPTION_ERROR_NOTACTIVATED,
	SUBSCRIPTION_ERROR_TRYAGAIN,
} from '../../../../constants/Copy';
import './Subscription.scss';
import './details/SubscriptionDetails.scss';
import { useSubscriptionCancellationStatus } from '../../subscription/useSubscriptionCancellationStatus';
import TierDetails from '../tierdetails/TierDetails';
import { TIER_IDS } from '../../../../constants/Tiers';
import { isOnFreeTier } from '../../../../helpers/tiers';

function renderSubscriptionDetails({ paymentDetails }) {
	return <SubscriptionDetails paymentDetails={paymentDetails} />;
}

function renderError(cancel = {}, reactivate = {}) {
	if (!cancel.error && !reactivate.error) return null;

	const isReactivateError = reactivate.error;

	return () => (
		<p className="profile__subscription-details-text profile__subscription-details-text--error">
			{ERROR_GENERIC} {isReactivateError ? SUBSCRIPTION_ERROR_NOTACTIVATED : null}
			<br />
			{isReactivateError ? SUBSCRIPTION_ERROR_TRYAGAIN : SUBSCRIPTION_ERROR_NOCANCEL}
		</p>
	);
}

const isTieringEnabled = (currentPlan) => {
	return currentPlan?.planDescription.tierId !== TIER_IDS.LEGACY;
};

export default ({
	subscription,
	currentPlan,
	tierSwitch,
	nextTier,
	paymentDetails,
	isTvGemistFallbackEnabled,
	onRefetchTvGemistFallback,
	isLoading,
}) => {
	const { cancel, reactivate, load, tier } = subscription;
	const { isCancelled } = useSubscriptionCancellationStatus();

	const timerRef = useRef(null);
	const [isPending, setIsPending] = useState(true);
	useEffect(() => {
		clearTimeout(timerRef.current);
		timerRef.current = setTimeout(
			() => setIsPending(reactivate.pending || load.pending || cancel.pending || tier.pending),
			300
		);
		return () => {
			clearTimeout(timerRef.current);
		};
	}, [reactivate.pending, load.pending, cancel.pending, tier.pending, timerRef]);

	return stateRender({
		isError: renderError(cancel, reactivate),
		onSuccess: () => (
			<Fragment>
				{!tierSwitch || !isTieringEnabled(currentPlan) ? null : (
					<TierDetails
						currentPlan={currentPlan}
						tierSwitch={tierSwitch}
						nextTier={nextTier}
						subscriptionGraphQlDetails={subscription}
						isCancelled={isCancelled}
						isTvGemistFallbackEnabled={isTvGemistFallbackEnabled}
						onRefetchTvGemistFallback={onRefetchTvGemistFallback}
						isLoading={isPending || isLoading}
					/>
				)}
				{paymentDetails?.me?.paymentDetails &&
					!isOnFreeTier(currentPlan.planDescription.tierId) && (
						<div className="profile__subscription-details">
							{renderSubscriptionDetails({
								isCancelled,
								paymentDetails,
							})}
						</div>
					)}
			</Fragment>
		),
	});
};
